module.exports = __webpack_public_path__ + "static/oni-222c28fe4ecb8b9a5cc97ee4278ee931.jpg";